<template lang="html">
    <data-table
        :headers="datatable.headers"
        :endpoint="datatable.endpoint"
        :toolbar="datatable.toolbar"
        :actions="datatable.actions"
        :views="datatable.views"
        :customRouteName="' ' + decodeURIComponent(this.$route.path.split('/')[2])"
        @rowClick="rowClick"
        storeId="products"
        ref="list"
        selectable
    >

        <template slot="items" slot-scope="props">
            <td>
                {{ props.item.label }}
            </td>
            <td v-if="props.item.supplier" class="text-xs-right">
                {{ props.item.supplier.name }}
            </td>
            <td v-else></td>
            <td class="text-xs-right">
                {{ props.item.code }}
            </td>
            <td class="text-xs-right">
                {{ moment(props.item.updated_at).format('L') }}
            </td>
            <td v-if="props.item.category && props.item.category.parent" class="text-xs-right">
                {{ props.item.category.parent.label }}
            </td>
            <td v-else></td>
            <td v-if="props.item.category" class="text-xs-right">
                {{ props.item.category.code }}
            </td>
            <td v-else></td>
            <td v-if="props.item" class="text-xs-right">
                <avatar :defaultImg="require('../../../assets/img/defaultProduct.png')" :item="props.item" field="photo"></avatar>
            </td>
        </template>

    </data-table>
</template>

<script>
import DataTable from '../../../components/DataTable.vue'
import Avatar from '../../../components/avatar/Avatar.vue'
import Delete from './Delete.vue'
import Create from './Create.vue'
import moment from 'moment'
moment.locale('fr')

export default {
	components: { DataTable, Avatar },

	props: {
		filter: {
			required: false
		}
	},

	data() {
		return {
			datatable: {
				toolbar: [
                    { icon: 'delete', callback: () => { this.$eventHub.$emit('open-modal', Delete) }, level: 60 },
                    // { icon: 'edit', callback: () => {  } }
                ],
                actions: [
                    { text: 'Ajouter un produit', icon: 'add_circle', callback: () => {this.$eventHub.$emit('open-modal', Create)}, level: 60}
                ],
				views: [
					{ text: this.$route.params.group+' Sidamo', link: 'products-group' ,
                        params:{group :this.$route.params.group}
                    },
					{ text: this.$route.params.group+' Fournisseurs', link:'products-suppliers',
                        params:{group :this.$route.params.group}
                    },
					{ text: this.$route.params.group+' Concurrents', link:'products-competitors',
                        params:{group :this.$route.params.group}
                    },
				],
				headers: [
					{ text: 'DESIGNATION',         sortable: true, value: 'label', align: 'left' },
					{ text: 'FOURNISSEUR',         sortable: false, value: 'supplier.name', align: 'right' },
					{ text: 'CODE ARTICLE',        sortable: true, value: 'code', align: 'right' },
                    { text: 'DERNIÈRE MODIFICATION',        sortable: true, value: 'updated_at', align: 'right' },
					{ text: 'FAMILLE',             sortable: false, value: 'category.parent.label', align: 'right' },
					{ text: 'CODE SOUS FAMILLE',   sortable: false, value: 'category.code', align: 'right' },
                    { text: 'PHOTO',                sortable: false, align: 'right'}
				],
				endpoint: {
					base: '/api/products',
					filters: this.setFilters,
					embed: 'supplier,category.parent.parent,group'
				}
			},
            moment,
		}
	},

	methods: {
		rowClick(item) {
			this.$router.push({ name: 'single-product', params: { group: this.$route.params.group,id: item.id } })
		},

		setFilters() {
            let filter ='';
			if (this.filter && this.fixed_filters) {
				filter = this.fixed_filters + ',' + this.filter

			} else if (this.filter) {
				filter = this.filter
			} else if (this.fixed_filters) {
				filter = this.fixed_filters
			}
            filter = filter + ',group|=|'+this.$route.params.group;

            this.datatable.endpoint.filters = filter;
        }
	},

	watch: {
		$route(val) {
			this.setFilters()
			this.$refs.list.reload()
            this.datatable.views[0].text = val.params.group+' Sidamo'
            this.datatable.views[1].text = val.params.group+' Fournisseurs'
            this.datatable.views[2].text = val.params.group+' Concurrents'
		}
	},

	created() {
		this.$eventHub.$on('reload-list', () => {
			if (this.$refs.list) {
				this.$refs.list.reload()
			}
		})

		this.setFilters()
	}
}
</script>

<style lang="stylus" scoped>

</style>



// WEBPACK FOOTER //
// src/views/products/list/List.vue